<template>
    <Modal id="TelefoneComplementar_Crud" :open="show" :FooterDefault="false" :ClassBG="true" :size="''">

        <template v-slot:header>
            <h6 class="modal-title">Telefone Complementar</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>

        <template v-slot:body>
            <div class="body">
                <div class="container-fluid">

                    <Form ref="ABCD" @submit="submitFormTelefone">
                        <div class="d-flex">
                            <div class="flex-fill">
                                <label class="form-label">Telefone ou Celular *</label>
                                <Field v-model="telefone_Crud.nrTelefone" name="nrTelefone" type="text" label="Telefone"
                                       rules="required" class="shadow-v2 form-control" v-maska="maskaInput" />
                                <ErrorMessage name="nrTelefone" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="flex-fill ms-2">
                                <label class="form-label">Ramal</label>
                                <Field v-model="telefone_Crud.nrRamal" type="number" name="nrRamal" class="shadow-v2 form-control" />
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="flex-fill mt-2">
                                <label class="form-label">Observações *</label>
                                <textarea v-model="telefone_Crud.txObservacoesInput" class="form-control textarea shadow-v2" placeholder="Escreva..."></textarea>
                                <Field name="telefone_Crud_dsObservacao" label="Observações" type="hidden" v-model="telefone_Crud.dsObservacao" rules="required" />
                                <ErrorMessage name="telefone_Crud_dsObservacao" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="flex-fill mt-2">
                                <label class="form-label">Ativo *</label>
                                <select v-model="Drop_Ativo" class="form-select shadow-v2">
                                    <option :value="'true'" selected>Sim</option>
                                    <option :value="'false'">Não</option>
                                </select>
                                <Field name="flAtivo" type="hidden" :rules="{ required: true }" v-model="telefone_Crud.flAtivo" />
                                <ErrorMessage name="flAtivo" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="flex-fill ms-2 mt-2">
                                <label class="form-label">Prioritário *</label>
                                <select v-model="Drop_Prioritario" class="form-select shadow-v2">
                                    <option :value="'true'">Sim</option>
                                    <option :value="'false'" selected>Não</option>
                                </select>
                                <Field name="flPrioritario" type="hidden" :rules="{ required: true }" v-model="telefone_Crud.flPrioritario" />
                                <ErrorMessage name="flPrioritario" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                    </Form>

                </div>
            </div>
        </template>

        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal" @click="fecharModal()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-red-v2" @click="submitFormTelefone">
                    <span v-if="idPessoaTelefone > 0">
                        <i class="fa fa-save pe-2" aria-hidden="true"></i>
                        Alterar
                    </span>
                    <span v-else>
                        <i class="fa fa-save pe-2" aria-hidden="true"></i>
                        Incluir
                    </span>
                </button>
            </div>
        </template>

    </Modal>
</template>

<script>

    import axios from 'axios';
    import Modal from "@/components/App/Modal.vue";
    import { maska } from "maska";

    export default {
        name: "TelefoneComplementar_Crud",
        components: {
            Modal,
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idPessoa: {
                type: Number,
                default: 0
            },
            idPessoaTelefone: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                telefone_Crud: {
                    nrTelefone: '',
                    nrRamal: 0,
                    txObservacoesInput: '',
                    dsObservacao: '',
                    flAtivo: 'true',
                    flPrioritario: 'false',
                    idTelefone: 0,
                },

                Drop_Ativo: true,
                Drop_Prioritario: false,
                showErrorMessage: false,
                maskaInput: ['(##) ####-####', '(##) #####-####'],
                isFocused: false,
            }
        },
        methods: {
            get() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaTelefone/GetById?idPessoaTelefone=' + $this.idPessoaTelefone, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.telefone_Crud = response.data.data;
                    $this.telefone_Crud.nrRamal = parseInt($this.telefone_Crud.nrRamal) || 0;
                    $this.telefone_Crud.txObservacoesInput = $this.telefone_Crud.dsObservacao;
                    if ($this.telefone_Crud.flAtivo == 'Sim') {
                        $this.telefone_Crud.flAtivo = 'true';
                    }
                    else if ($this.telefone_Crud.flAtivo == 'Não') {
                        $this.telefone_Crud.flAtivo = 'false';
                    }
                    if ($this.telefone_Crud.flPrioritario == 'Sim') {
                        $this.telefone_Crud.flPrioritario = 'true';
                    }
                    else if ($this.telefone_Crud.flPrioritario == 'Não') {
                        $this.telefone_Crud.flPrioritario = 'false';
                    }
                })
            },
            validarTelefone(telefone) {
                const regex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
                return regex.test(telefone);
            },
            fecharModal() {
                this.$emit('fecharModalTelefone');
            },
            submitFormTelefone() {
                let $this = this;

                $this.$refs.ABCD.validate()
                    .then(isValid => {
                        if (isValid.valid) {
                            if (!$this.validarTelefone($this.telefone_Crud.nrTelefone)) {
                                $this.$toast.show('alert', 'Telefone ou celular é obrigatório e deve estar completo!', true);
                                return;
                            }

                            this.telefone_Crud.flAtivo = this.telefone_Crud.flAtivo === 'true' ? true : false;
                            this.telefone_Crud.flPrioritario = this.telefone_Crud.flPrioritario === 'true' ? true : false;
                            this.telefone_Crud.idPessoaTelefone = this.idPessoaTelefone;
                            this.telefone_Crud.nrRamal = parseInt(this.telefone_Crud.nrRamal) || 0;

                            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PessoaTelefone/Post', $this.telefone_Crud, { headers: $this.$api.getTokenComercial() })
                                .then(function (response) {
                                    $this.fecharModal();
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }
                                    $this.$toast.show('alert', msg, true);
                                });

                            $this.showErrorMessage = false;
                        }
                        else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigatórios.';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            zerarInformacoes() {
                let $this = this;

                $this.telefone_Crud = {
                    nrTelefone: '',
                    nrRamal: 0,
                    txObservacoesInput: '',
                    dsObservacao: '',
                    flPrioritario: 'false',
                    flAtivo: 'true',
                };
                $this.telefone_Crud.idPessoa = $this.idPessoa;
                $this.showErrorMessage = false;
            },
        },
        mounted() { },
        watch: {
            show(newValue, oldValue) {
                if (this.telefone_Crud.idPessoaTelefone > 0) {
                    this.get();
                } else {
                    this.zerarInformacoes();
                }
            },
            idPessoa(newValue, oldValue) {
                this.telefone_Crud.idPessoa = newValue;
            },
            idPessoaTelefone(newValue, oldValue) {
                this.telefone_Crud.idPessoaTelefone = newValue;
                if (this.telefone_Crud.idPessoaTelefone > 0) {
                    this.get();
                }
            },
            'telefone_Crud.txObservacoesInput'(newVal, oldVal) {
                this.telefone_Crud.dsObservacao = newVal;
            },
            Drop_Ativo(newValue, oldValue) {
                this.telefone_Crud.flAtivo = newValue;
            },
            Drop_Prioritario(newValue, oldValue) {
                this.telefone_Crud.flPrioritario = newValue;
            },
        },
    }

</script>

<style scoped>

    .body {
        min-height: calc(100vh - 7rem);
        max-height: calc(100vh - 7rem);
        overflow-y: auto !important;
        overflow-x: hidden !important;
    }

    .textarea {
        height: 100px !important;
    }
</style>